export function VideoPrview({ url }: { url: string }) {
  return <video controls src={url} width="100%" height={200}></video>
}
